import { agentProviders } from 'app.constants';
export const AVAILABLE_AGENT_MODELS = agentProviders.map((provider) => provider.model)
    .reduce((acc, val) => acc.concat(val), []);
export const LEGACY_AGENT_MODELS = ['gpt-4.1', 'gpt-4.1-mini', 'gpt-4.1-nano'];
export const MODELMAP_PROVIDER = agentProviders
    .reduce((acc, val) => {
    val.model.forEach(modelName => {
        acc[modelName] = val.provider;
    });
    return acc;
}, {});
export const BLIP_GOOGLE_PROVIDER = 'blip-google';
export const DEFAULT_PROVIDER = 'blip';
export function hasPdfFileRestriction(modelName) {
    const provider = MODELMAP_PROVIDER[modelName];
    return provider === BLIP_GOOGLE_PROVIDER;
}
